import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import { StyledEngineProvider } from '@mui/material/styles';
import { ROWS_PER_PAGE_OPTIONS } from './constants';
import { DataGridTableProps } from './types';
import { paginationStyling } from './helpers';
import { useDataGridTable } from './hooks';
import {
  TableToolbar,
  DataGridTableHead,
  DataGridTableBody,
  DataGridSidePanel,
} from './components';

import styles from './DataGridTable.module.scss';

export const DataGridTable = (props: DataGridTableProps) => {
  const {
    isAccreditationGridTable,
    accreditationGridTable,
    isPPproject,
    title,
    columns,
    sidePanel,
    isManagersTable,
    loading,
    hasFetched,
    order,
    orderBy,
    searchQuery,
    isSortDisabled,
    currentNominatedForDinnerCount,
    currentApplicationsPerRoleCount,
    page,
    rowsPerPage,
    filteredRows,
    visibleRows,
    filteredItems,
    isPanelOpen,
    selectedItem,
    wrapperRef,
    setIsPanelOpen,
    setSelectedItem,
    handleSearchChange,
    handleRequestSort,
    handleChangePage,
    handleChangeRowsPerPage,
    handleRowClick,
    handleAccreditationFormClosed,
    kontentItemId,
  } = useDataGridTable(props);

  const mergedAccreditationGridTable = accreditationGridTable
    ? {
        ...accreditationGridTable,
        currentNominatedForDinnerCount,
        currentApplicationsPerRoleCount,
      }
    : undefined;

  return (
    <StyledEngineProvider injectFirst>
      <div
        className={styles.wrapper}
        ref={wrapperRef}
        data-kontent-item-id={kontentItemId}
      >
        <TableToolbar
          title={title}
          searchQuery={searchQuery}
          onSearchChange={handleSearchChange}
          accreditationGridTable={mergedAccreditationGridTable}
          onAccreditationFormClosed={handleAccreditationFormClosed}
          accreditationsFetched={hasFetched}
        />
        <TableContainer>
          <Table className={styles.gridTable}>
            <DataGridTableHead
              columns={columns}
              order={order}
              orderBy={orderBy}
              isSortDisabled={isSortDisabled}
              onRequestSort={handleRequestSort}
            />
            <DataGridTableBody
              columns={columns}
              visibleRows={visibleRows}
              loading={loading}
              hasFetched={hasFetched}
              isManagersTable={
                isAccreditationGridTable ? false : isManagersTable
              }
              isAccreditationGridTable={isAccreditationGridTable}
              maxNumberOfApplicationsPerRole={
                accreditationGridTable?.maxNumberOfApplicationsPerRole
              }
              onRowClick={handleRowClick}
            />
          </Table>
        </TableContainer>
        {!isAccreditationGridTable && (
          <TablePagination
            rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            className={styles.pagination}
            sx={paginationStyling}
          />
        )}
      </div>

      <DataGridSidePanel
        isPPproject={isPPproject}
        sidePanel={sidePanel}
        isPanelOpen={isPanelOpen}
        setIsPanelOpen={setIsPanelOpen}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        filteredItems={filteredItems}
      />
    </StyledEngineProvider>
  );
};

export default DataGridTable;
